module.exports = __webpack_public_path__ + "img/bgc13.aba798f5.png";